import React from 'react'
import { useStyles } from './styles'
import { CowFaceIcon, CowIcon, GenderFemaleIcon, GenderMaleIcon, LetterRIcon, TicketIcon } from 'src/assets/svg'
import { IAnimal } from 'src/dto/animal.dto'

interface IAnimalCard {
  cardData: IAnimal
}

export const AnimalCard = ({ cardData }: IAnimalCard) => {
  const styles = useStyles()
  const { cdn, nome, rgn, raca, sexo, categoria } = cardData

  let statusLabel = ''
  if (categoria === 'VD') statusLabel = 'Vendido'
  if (categoria === 'MT') statusLabel = 'Morto'

  return (
    <div className={styles.cardContainer} style={{ cursor: 'pointer' }}>
      {statusLabel && <span className={styles.statusChip}>{statusLabel}</span>}
      <div className={styles.cardContent}>
        <div className={styles.cardHeader}>
          <div className={styles.cardHeaderIcon}>
            <CowIcon className={styles.cardHeaderSvgIcon} />
          </div>
          <span className={styles.cardHeaderText}>{nome || '-'}</span>
        </div>
        <div className={styles.cardBodyInformation}>
          <div className={styles.cardBodyInformationItem}>
            <span className={styles.cardBodyInformationItemIcon}>
              <TicketIcon />
            </span>
            <span className={styles.cardBodyInformationItemText}>{cdn || '-'}</span>
          </div>
          <div className={styles.cardBodyInformationItem}>
            <span className={styles.cardBodyInformationItemIcon}>
              <LetterRIcon />
            </span>
            <span className={styles.cardBodyInformationItemText}>{rgn || '-'}</span>
          </div>
          <div className={styles.cardBodyInformationItemFooter}>
            <div className={styles.cardBodyInformationItem}>
              <span className={styles.cardBodyInformationItemIcon}>
                <CowFaceIcon />
              </span>
              <span className={styles.cardBodyInformationItemText}>{raca || '-'}</span>
            </div>
            <span className={styles.cardBodyInformationItemIcon}>
              {sexo === 'F' ? <GenderFemaleIcon /> : <GenderMaleIcon />}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
